<!-- Lista de filtros, usada no tratamento e em cada variável da fórmula -->
<ng-template #filtrosTpl let-lista="lista" let-prefixo="prefixo">
  <div class="linha" *ngFor="let f of lista; let k = index">
    <input pInputText [attr.id]="prefixo + 'Campo' + k" [(ngModel)]="f.campo" placeholder="Campo" style="min-width: 10rem" />
    <p-dropdown [options]="operadores" [(ngModel)]="f.tipoOperador" optionLabel="label" optionValue="value" styleClass="w-12rem" appendTo="body"></p-dropdown>
    <input *ngIf="!operadorSemValor(f.tipoOperador)" pInputText [attr.id]="prefixo + 'Valor' + k" [(ngModel)]="f.valor" placeholder="Valor" style="min-width: 8rem" />
    <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger" (onClick)="remover(lista, k)" pTooltip="Remover filtro"></p-button>
  </div>
  <p-button label="Adicionar filtro" icon="pi pi-plus" styleClass="p-button-sm p-button-text" (onClick)="adicionarFiltro(lista)"></p-button>
</ng-template>

<!-- Lista de ordenação, usada globalmente e em PRIMEIRO/ULTIMO -->
<ng-template #ordenacaoTpl let-lista="lista" let-prefixo="prefixo">
  <div class="linha" *ngFor="let o of lista; let k = index">
    <input pInputText [attr.id]="prefixo + k" [(ngModel)]="o.campo" placeholder="Campo" style="min-width: 12rem" />
    <p-dropdown [options]="direcoes" [(ngModel)]="o.direcao" optionLabel="label" optionValue="value" styleClass="w-12rem" appendTo="body"></p-dropdown>
    <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger" (onClick)="remover(lista, k)" pTooltip="Remover"></p-button>
  </div>
  <p-button label="Adicionar campo de ordenação" icon="pi pi-plus" styleClass="p-button-sm p-button-text" (onClick)="adicionarOrdenacao(lista)"></p-button>
</ng-template>

<div class="grid config-grid">
  <!-- 1. Chaves -->
  <div class="col-12" [hidden]="aba !== 'chaves'">
    <h4 class="mt-0 mb-1">Agrupar por</h4>
    <small class="dica">Registros com a mesma combinação destes campos formam um grupo (um registro por grupo no resultado).</small>
    <div class="linha" *ngFor="let c of model.chaves; let i = index">
      <input pInputText [attr.id]="'agrChave' + i" [(ngModel)]="c.campo" placeholder="Campo (ex.: started)" style="min-width: 14rem" />
      <p-dropdown [options]="transformacoes" [(ngModel)]="c.transformacao" optionLabel="label" optionValue="value" styleClass="w-18rem" appendTo="body"></p-dropdown>
      <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger" (onClick)="removerChave(i)" pTooltip="Remover"></p-button>
    </div>
    <p-button label="Adicionar campo de agrupamento" icon="pi pi-plus" styleClass="p-button-sm p-button-text" (onClick)="adicionarChave()"></p-button>
  </div>

  <!-- 2. Ordenação -->
  <div class="col-12" [hidden]="aba !== 'ordenacao'">
    <h4 class="mb-1">Ordenação dos registros de cada grupo <span class="text-500 text-sm font-normal">(opcional)</span></h4>
    <small class="dica">Define qual é o "primeiro" e o "último" registro. A ordenação compara texto, não números (10 vem antes de 9).</small>
    <ng-container *ngTemplateOutlet="ordenacaoTpl; context: { lista: model.camposOrdenar, prefixo: 'agrOrdenar' }"></ng-container>
  </div>

  <!-- 3. Tratamentos -->
  <div class="col-12" [hidden]="aba !== 'tratamentos'">
    <h4 class="mb-1">Tratamentos</h4>
    <small class="dica">Cada tratamento calcula um campo do registro resultante a partir dos registros do grupo.</small>

    <div class="tratamento" *ngFor="let t of model.tratamentos; let i = index" [attr.id]="'tratamento' + i">
      <div class="tratamento-cabecalho">
        <strong>Tratamento {{ i + 1 }}</strong>
        <span class="text-500">{{ rotuloOperacao(t.tipoOperacao) }}<ng-container *ngIf="destinoEfetivo(t)"> → {{ destinoEfetivo(t) }}</ng-container></span>
        <span class="flex-grow-1"></span>
        <p-button icon="pi pi-arrow-up" styleClass="p-button-rounded p-button-text p-button-sm" [disabled]="i === 0" (onClick)="moverTratamento(i, -1)" pTooltip="Subir"></p-button>
        <p-button icon="pi pi-arrow-down" styleClass="p-button-rounded p-button-text p-button-sm" [disabled]="i === model.tratamentos.length - 1" (onClick)="moverTratamento(i, 1)" pTooltip="Descer"></p-button>
        <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger p-button-sm" (onClick)="removerTratamento(i)" pTooltip="Remover tratamento"></p-button>
      </div>

      <div class="linha">
        <p-dropdown [attr.id]="'trOp' + i" [options]="operacoes" [(ngModel)]="t.tipoOperacao" optionLabel="label" optionValue="value" styleClass="w-16rem" appendTo="body"></p-dropdown>
        <input *ngIf="!semCampoFonte(t.tipoOperacao)" pInputText [attr.id]="'trCampo' + i" [(ngModel)]="t.nomeCampo" placeholder="Campo de origem" style="min-width: 12rem" />
        <i class="pi pi-arrow-right text-500"></i>
        <input pInputText [attr.id]="'trDestino' + i" [(ngModel)]="t.nomeDestino" [placeholder]="semCampoFonte(t.tipoOperacao) ? 'Campo de destino' : 'Destino (vazio = mesmo campo)'" style="min-width: 14rem" />
      </div>

      <!-- CONCATENAR -->
      <div class="linha" *ngIf="t.tipoOperacao === 'CONCATENAR'">
        <input pInputText [attr.id]="'trSeparador' + i" [(ngModel)]="t.separador" placeholder='Separador (vazio = ", ")' style="min-width: 12rem" />
      </div>

      <!-- PRIMEIRO / ULTIMO: ordenação própria -->
      <ng-container *ngIf="aceitaOrdenacao(t.tipoOperacao)">
        <div class="subtitulo">Ordenação deste tratamento <span class="text-500 text-sm font-normal">(vazio = usa a ordenação global)</span></div>
        <ng-container *ngTemplateOutlet="ordenacaoTpl; context: { lista: t.camposOrdenar, prefixo: 'trOrdenar' + i + '_' }"></ng-container>
      </ng-container>

      <!-- MINIMO / MAXIMO / PRIMEIRO / ULTIMO: campos adicionais -->
      <ng-container *ngIf="aceitaCamposAdicionais(t.tipoOperacao)">
        <div class="subtitulo">Campos adicionais <span class="text-500 text-sm font-normal">(copiados do registro escolhido, ex.: a data do valor mínimo)</span></div>
        <div class="linha" *ngFor="let c of t.camposAdicionais; let k = index">
          <input pInputText [attr.id]="'trAdicOrigem' + i + '_' + k" [(ngModel)]="c.nomeCampo" placeholder="Campo de origem" style="min-width: 12rem" />
          <i class="pi pi-arrow-right text-500"></i>
          <input pInputText [attr.id]="'trAdicDestino' + i + '_' + k" [(ngModel)]="c.nomeDestino" placeholder="Campo de destino" style="min-width: 12rem" />
          <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger" (onClick)="remover(t.camposAdicionais, k)" pTooltip="Remover"></p-button>
        </div>
        <p-button label="Adicionar campo adicional" icon="pi pi-plus" styleClass="p-button-sm p-button-text" (onClick)="adicionarCampoAdicional(t)"></p-button>
      </ng-container>

      <!-- FORMULA -->
      <ng-container *ngIf="t.tipoOperacao === 'FORMULA'">
        <div class="subtitulo">Fórmula (cálculo com as variáveis abaixo)</div>
        <small class="dica">Use nomes de variáveis, números e operadores (+, -, *, /); parênteses agrupam o cálculo. Ex.: (T7 + T14 + (2 * T21)) / 4. Técnico: expressão SpEL.</small>
        <textarea pInputTextarea [attr.id]="'trFormula' + i" [(ngModel)]="t.formula" rows="2" class="w-full font-mono" placeholder="(T7 + T14 + (2 * T21)) / 4"></textarea>
        <small class="dica aviso" *ngIf="naoDeclaradas(t).length > 0" [attr.id]="'trFormulaAviso' + i">
          <i class="pi pi-exclamation-triangle"></i> Usada e não declarada: {{ naoDeclaradas(t).join(', ') }}. Declare cada uma em "Variáveis".
        </small>
        <small class="dica">Erro na fórmula grava o campo vazio. Cada variável vale o campo do primeiro registro do grupo que passar nos filtros dela.</small>

        <div class="subtitulo">Variáveis</div>
        <div class="tratamento" *ngFor="let v of t.variaveis; let k = index">
          <div class="linha">
            <input pInputText [attr.id]="'trVarNome' + i + '_' + k" [(ngModel)]="v.nome" placeholder="Nome (ex.: T7)" style="min-width: 8rem" />
            <input pInputText [attr.id]="'trVarCampo' + i + '_' + k" [(ngModel)]="v.campo" placeholder="Campo do registro" style="min-width: 12rem" />
            <p-inputNumber [(ngModel)]="v.valorDefault" placeholder="Valor padrão" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="6" [useGrouping]="false"></p-inputNumber>
            <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger" (onClick)="remover(t.variaveis, k)" pTooltip="Remover variável"></p-button>
          </div>
          <div class="subtitulo">Filtros da variável</div>
          <ng-container *ngTemplateOutlet="filtrosTpl; context: { lista: v.filtros, prefixo: 'trVarFiltro' + i + '_' + k + '_' }"></ng-container>
        </div>
        <p-button label="Adicionar variável" icon="pi pi-plus" styleClass="p-button-sm p-button-text" (onClick)="adicionarVariavel(t)"></p-button>
      </ng-container>

      <!-- Filtros do tratamento -->
      <div class="subtitulo">Filtros do tratamento <span class="text-500 text-sm font-normal">(só os registros do grupo que passarem participam do cálculo)</span></div>
      <ng-container *ngTemplateOutlet="filtrosTpl; context: { lista: t.filtros, prefixo: 'trFiltro' + i + '_' }"></ng-container>
    </div>

    <p-button label="Adicionar tratamento" icon="pi pi-plus" styleClass="p-button-sm" (onClick)="adicionarTratamento()"></p-button>
  </div>

  <!-- 4. Opções -->
  <div class="col-12" [hidden]="aba !== 'opcoes'">
    <h4 class="mb-1">Opções</h4>
    <div class="flex align-items-center gap-2">
      <p-inputSwitch inputId="agrExclui" [(ngModel)]="model.excluiRegistros"></p-inputSwitch>
      <label for="agrExclui" class="font-bold">Excluir os registros de origem após agrupar</label>
    </div>
    <small class="dica aviso-destrutivo" *ngIf="model.excluiRegistros" id="agrAvisoExclui">
      <i class="pi pi-exclamation-triangle"></i> Ação destrutiva: os registros originais serão apagados e não poderão ser consultados depois.
    </small>
    <small class="dica" *ngIf="!model.excluiRegistros">Desligado, os registros de origem ficam marcados como AGRUPADO e o vínculo com o resultado é mantido.</small>
  </div>
</div>
